import { EnumHelper } from "@singularsystems/neo-core";

export enum enumFileExtension {
    csv = ".csv",
    prn = ".prn",
    txt = ".txt",
    xls = ".xls",
    xlsm = ".xlsm",
    xlsx = ".xlsx",
}

EnumHelper.decorateEnum(enumFileExtension, e => {
    e.describe(enumFileExtension.csv, ".csv");
    e.describe(enumFileExtension.prn, ".prn");
    e.describe(enumFileExtension.txt, ".txt");
    e.describe(enumFileExtension.xls, ".xls");
    e.describe(enumFileExtension.xlsm, ".xlsm");
    e.describe(enumFileExtension.xlsx, ".xlsx");
})